import { useEffect, useRef } from 'react';

// @ts-ignore
export default function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var targetRef = useRef();
  useEffect(function () {
    refs.forEach(function (r) {
      if (!r) return;
      if (typeof r === 'function') {
        r(targetRef.current);
      } else {
        r.current = targetRef.current;
      }
    });
  }, [refs]);
  return targetRef;
}